import SortableWidgetsList from './SortableWidgetsList';
export default SortableWidgetsList;
